import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaBuilding, FaSpinner } from 'react-icons/fa';
import { get, ref } from 'firebase/database';
import { realtimeDb } from '../../firebase';
import { normalizeCompanyKey } from '../../Utils/companyUtils';

const CompanySwitcher = ({ selectedCompany, onChange, refreshFlag, isLoading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setIsFetching(true);
        const snap = await get(ref(realtimeDb, 'companies'));
        if (snap.exists()) {
          const data = snap.val();
          const names = Object.keys(data).map(normalizeCompanyKey);
          setCompanies([...new Set(names)].sort());
        } else {
          setCompanies([]);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchCompanies();
  }, [refreshFlag]);

  useEffect(() => {
    const stored = localStorage.getItem('selectedCompany') || localStorage.getItem('userCompany');
    if (!selectedCompany && stored) {
      const normalized = normalizeCompanyKey(stored);
      onChange(normalized);
    }
  }, [selectedCompany, onChange]);

  const handleSelect = (company) => {
    const normalized = normalizeCompanyKey(company);
    onChange(normalized);
    localStorage.setItem('selectedCompany', normalized);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full md:w-64">
      <button
        onClick={() => setIsOpen(!isOpen)}
        disabled={isLoading}
        className={`flex items-center justify-between w-full bg-white border ${
          isOpen ? 'border-indigo-300 ring-2 ring-indigo-100' : 'border-gray-300'
        } rounded-lg px-3 py-2 text-left transition-all hover:border-indigo-300 disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        <div className="flex items-center gap-2 truncate">
          <FaBuilding className="text-indigo-600 flex-shrink-0" />
          <span className="truncate">{selectedCompany || 'Select Company'}</span>
        </div>
        {isFetching ? (
          <FaSpinner className="animate-spin text-gray-400" />
        ) : (
          <FaChevronDown
            className={`text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-lg border border-gray-200 overflow-hidden">
          <div className="max-h-60 overflow-y-auto">
            {companies.length === 0 ? (
              <div className="px-4 py-3 text-sm text-gray-500 text-center">
                {isFetching ? 'Loading companies...' : 'No companies available'}
              </div>
            ) : (
              companies.map((company) => (
                <button
                  key={company}
                  onClick={() => handleSelect(company)}
                  className={`flex items-center gap-2 w-full px-4 py-2.5 text-left text-sm ${
                    selectedCompany === company
                      ? 'bg-indigo-50 text-indigo-700'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <FaBuilding className="text-indigo-600 flex-shrink-0" />
                  <span className="truncate">{company}</span>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanySwitcher;